/* unplugin-vue-components disabled */import script from "./AddressEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressEdit.vue?vue&type=script&setup=true&lang=js"

import "./AddressEdit.vue?vue&type=style&index=0&id=78aaa657&lang=scss"

const __exports__ = script;

export default __exports__